import React, { FC, useEffect, useRef, useState } from 'react'
import { checkAutoLogin, signUpComplete } from '../../../../services/AuthServics'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { RegistrationSteps } from './RegistrationSteps'
import { Button } from 'react-bootstrap';
import { toastNotify } from '../../../../services/NotifyService';
import { toast } from 'react-toastify';
import { toAbsoluteUrl } from '../../../../_metronic/helpers';
import { useAuth } from '../core/Auth';

const RegisterComplete: FC = () => {
  const {currentUser, logout} = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [signUpOk, setSignUpOk] = useState(false);
  const [showStepper, setShowStepper] = useState(false);
  const [message, setMessage] = useState("");
  const [onboardStatus, setOnboardStatus] = useState(0);
  const { userKey } = useParams();

  const completeSignUpProcess = async () => {
    try {
      const id = toast.loading("Please wait...");
      setLoading(true);
      await signUpComplete(userKey).then((res: any) => {
        let _data = res.data;

        if (_data.data > 0) {
          setMessage(_data.message);
          setSignUpOk(true);
          setOnboardStatus(_data.data)
        }
        toastNotify(id, res);

        setLoading(false);
      })
        .catch((err: any) => {
          const res = { data: { message: 'Something went wrong', success: false } };
          toastNotify(id, res);
          console.error(err);
          setLoading(false);
        }).finally(() => {
          setLoading(false);
        });
    } catch (error) {
      setLoading(false)
    }
  }

  const redirect = async () => {
    if (onboardStatus === 1) {
      navigate('/auth');
    } else {
      navigate(`/onboarding-steps/${userKey}`)
      // setShowStepper(true);
    }
    // navigate('/auth');
  }

  useEffect(() => {
    logout();
    completeSignUpProcess();
  }, [])

  return (
    <div className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-start bgi-no-repeat bgi-size-contain bgi-attachment-fixed'>
      <div className='d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20'>
        <div className='card w-900px'>
          <div className='card-body'>
            <div className="text-center mb-lg-10">
              {/* begin::Logo */}
              <Link to='/' className='mb-12'>
                <img alt='Amber Bills' title='Amber Bills' src={toAbsoluteUrl('/media/logos/logo1.png')} className='h-50px ' />
              </Link>
              {/* end::Logo */}
            </div>
            {
              signUpOk && showStepper === false && (
                <div className='w-100'>

                  {/* begin::Alert*/}
                  <div className="alert alert-dismissible d-flex flex-center flex-column py-10 px-10 px-lg-20" style={{ margin: '-33px' }}>
                    {/* begin::Close*/}
                    {/* <button type="button" className="position-absolute top-0 end-0 m-2 btn btn-icon btn-icon-success" data-bs-dismiss="alert">
                <img src="/media/icons/duotune/abstract/abs012.svg" className="h-20px me-10" />
              </button> */}
                    {/* end::Close*/}

                    {/* begin::Icon*/}
                    <span className="svg-icon svg-icon-5hx svg-icon-success me-4 mb-5">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path opacity="0.3" d="M20.5543 4.37824L12.1798 2.02473C12.0626 1.99176 11.9376 1.99176 11.8203 2.02473L3.44572 4.37824C3.18118 4.45258 3 4.6807 3 4.93945V13.569C3 14.6914 3.48509 15.8404 4.4417 16.984C5.17231 17.8575 6.18314 18.7345 7.446 19.5909C9.56752 21.0295 11.6566 21.912 11.7445 21.9488C11.8258 21.9829 11.9129 22 12.0001 22C12.0872 22 12.1744 21.983 12.2557 21.9488C12.3435 21.912 14.4326 21.0295 16.5541 19.5909C17.8169 18.7345 18.8277 17.8575 19.5584 16.984C20.515 15.8404 21 14.6914 21 13.569V4.93945C21 4.6807 20.8189 4.45258 20.5543 4.37824Z" fill="currentColor"></path>
                        <path d="M10.5606 11.3042L9.57283 10.3018C9.28174 10.0065 8.80522 10.0065 8.51412 10.3018C8.22897 10.5912 8.22897 11.0559 8.51412 11.3452L10.4182 13.2773C10.8099 13.6747 11.451 13.6747 11.8427 13.2773L15.4859 9.58051C15.771 9.29117 15.771 8.82648 15.4859 8.53714C15.1948 8.24176 14.7183 8.24176 14.4272 8.53714L11.7002 11.3042C11.3869 11.6221 10.874 11.6221 10.5606 11.3042Z" fill="currentColor"></path>
                      </svg>
                    </span>
                    {/* end::Icon*/}

                    {/* begin::Wrapper*/}
                    <div className="text-center">
                      {/* begin::Title*/}
                      <h1 className="fw-bold mb-5">Email confirmation successful.</h1>
                      {/* end::Title*/}

                      {/* begin::Separator*/}
                      <div className="separator separator-dashed border-success opacity-25 mb-5"></div>
                      {/* end::Separator*/}

                      {/* begin::Content*/}
                      <div className="mb-9 text-dark fs-5">
                        {message}
                      </div>
                      {/* end::Content*/}

                      {/* begin::Buttons*/}
                      <div className="d-flex flex-center flex-wrap">
                        {/* <a href="#" className="btn btn-outline btn-outline-success btn-active-success m-2">Cancel</a> */}
                        <Button className="btn btn-success m-2" onClick={() => redirect()}>Continue</Button>
                      </div>
                      {/* end::Buttons*/}
                    </div>
                    {/* end::Wrapper*/}
                  </div>
                  {/* end::Alert*/}
                </div>
              )
            }
            {showStepper && (<></>
              // <RegistrationSteps />
            )
            }
            {currentUser && (<>
              <div className="text-center"> 
              <div className="separator separator-dashed border-success opacity-25 mb-5">
                <div className="d-flex flex-center flex-wrap">
                  <Button className="btn btn-success m-2" onClick={() => redirect()}>Continue</Button>
                  </div>
                </div>
              </div>
            </>)}
          </div>
        </div>
      </div>
    </div>
  )
}

export { RegisterComplete }


